export default {"src":"/_next/static/media/gtick.83967af4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};